import { Injectable } from '@angular/core';
import { ApiConfigService } from './api-config.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnquiryItem, EnquiryStats } from '../../models/enquiry.interface';

@Injectable({
  providedIn: 'root'
})
export class EnquiryService {
  private get apiUrl(): string { return `${this.apiConfig.apiUrl}/enquiries`; }

  constructor(private http: HttpClient, private apiConfig: ApiConfigService) {}

  getEnquiries(status = 'all', search = '', page = 1): Observable<{ enquiries: EnquiryItem[]; total: number; page: number; pages: number }> {
    let params = new HttpParams().set('page', page).set('limit', 50);
    if (status && status !== 'all') params = params.set('status', status);
    if (search) params = params.set('search', search);

    return this.http.get<{ enquiries: EnquiryItem[]; total: number; page: number; pages: number }>(this.apiUrl, { params });
  }

  getStats(): Observable<EnquiryStats> {
    return this.http.get<EnquiryStats>(`${this.apiUrl}/stats`);
  }

  updateStatus(id: string, status: string, notes?: string): Observable<EnquiryItem> {
    return this.http.put<EnquiryItem>(`${this.apiUrl}/${id}`, { status, notes });
  }

  deleteEnquiry(id: string): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.apiUrl}/${id}`);
  }
}



